import { render } from "./Windows10Loading.vue?vue&type=template&id=8a7a46c6&scoped=true&ts=true"
import script from "./Windows10Loading.vue?vue&type=script&lang=ts"
export * from "./Windows10Loading.vue?vue&type=script&lang=ts"

import "./Windows10Loading.vue?vue&type=style&index=0&id=8a7a46c6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7a46c6"]])

export default __exports__